type PlayerType = 'youtube' | 'vimeo';

interface PlayerConfigs {
	type: PlayerType;
	pauseCommand: string;
	formatMessage: (cmd: string) => Record<string, unknown>;
}

const defaultPlayerConfigs: PlayerConfigs[] = [
	{
		type: 'youtube',
		pauseCommand: 'pauseVideo',
		formatMessage: (cmd) => ({ event: 'command', func: cmd }),
	},
	{
		type: 'vimeo',
		pauseCommand: 'pause',
		formatMessage: (cmd) => ({ method: cmd }),
	},
];

/**
 * Pause all YouTube and Vimeo iframes on the page.
 *
 * Uses `postMessage()` to send a command to each iframe.
 * `iframe.contentWindow` gives a reference to the iframe’s window,
 * and `postMessage` lets us safely tell it to pause.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
 */
export default function pausePlayers(playerConfigs = defaultPlayerConfigs): void {
	playerConfigs.forEach(({ type, pauseCommand, formatMessage }) => {
		const iframes = Array.from(document.querySelectorAll<HTMLIFrameElement>(`iframe[id*=${type}]`));

		iframes.forEach((iframe) => {
			if (!iframe.contentWindow) return;
			iframe.contentWindow.postMessage(JSON.stringify(formatMessage(pauseCommand)), '*');
		});
	});
}
